var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 4H4.99982C4.20417 4 3.44111 4.31607 2.8785 4.87868C2.31589 5.44129 1.99982 6.20435 1.99982 7V17C1.99982 17.7956 2.31589 18.5587 2.8785 19.1213C3.44111 19.6839 4.20417 20 4.99982 20H18.9998C19.7955 20 20.5585 19.6839 21.1211 19.1213C21.6837 18.5587 21.9998 17.7956 21.9998 17V7C21.9998 6.20435 21.6837 5.44129 21.1211 4.87868C20.5585 4.31607 19.7955 4 18.9998 4ZM18.3298 6L11.9998 10.75L5.66982 6H18.3298ZM18.9998 18H4.99982C4.7346 18 4.48025 17.8946 4.29271 17.7071C4.10517 17.5196 3.99982 17.2652 3.99982 17V7.25L11.3998 12.8C11.5729 12.9298 11.7834 13 11.9998 13C12.2162 13 12.4267 12.9298 12.5998 12.8L19.9998 7.25V17C19.9998 17.2652 19.8945 17.5196 19.7069 17.7071C19.5194 17.8946 19.265 18 18.9998 18Z",
    fill: "#FC5027"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/emailIcon.f957a509.svg";
export { ForwardRef as ReactComponent };